import { appInject, appInjectable } from "@core/di/utils";
import { BaseService } from "@core/services/base";
import { DI_TOKENS } from "@shared/constants/di";
import { IConfigService } from "@shared/interfaces/config-service.interface";
import { IHttpClientService } from "@shared/interfaces/http-client-service.interface";
import { IHomeHeroCardsService } from "@shared/interfaces/home-hero-cards-service.interface";
import {
  CreateHomeHeroCardDto,
  HomeHeroCardDto,
  UpdateHomeHeroCardDto,
} from "@shared/types/home-hero-card/home-hero-card.dto";

@appInjectable()
export class HomeHeroCardsService
  extends BaseService
  implements IHomeHeroCardsService
{
  private configService = appInject<IConfigService>(DI_TOKENS.configService);
  private httpClient = appInject<IHttpClientService>(
    DI_TOKENS.httpClientService,
  );
  private baseURL: string;

  constructor() {
    super();
    this.baseURL = this.configService.baseUrl;
  }

  create: IHomeHeroCardsService["create"] = async (
    dto: CreateHomeHeroCardDto,
  ) => {
    const { data } = await this.httpClient.post<{
      data: { card: HomeHeroCardDto };
    }>("/home-hero-cards", dto, { baseURL: this.baseURL });
    return data.data.card;
  };

  list: IHomeHeroCardsService["list"] = async () => {
    const { data } = await this.httpClient.get<{
      data: { cards: HomeHeroCardDto[] };
    }>("/home-hero-cards", { baseURL: this.baseURL });
    return data.data.cards;
  };

  get: IHomeHeroCardsService["get"] = async (id: string) => {
    const { data } = await this.httpClient.get<{
      data: { card: HomeHeroCardDto };
    }>(`/home-hero-cards/${id}`, { baseURL: this.baseURL });
    return data.data.card;
  };

  update: IHomeHeroCardsService["update"] = async (
    dto: UpdateHomeHeroCardDto,
  ) => {
    const { id, ...body } = dto;
    const { data } = await this.httpClient.patch<{
      data: { card: HomeHeroCardDto };
    }>(`/home-hero-cards/${id}`, body, { baseURL: this.baseURL });
    return data.data.card;
  };

  delete: IHomeHeroCardsService["delete"] = async (id: string) => {
    await this.httpClient.delete(`/home-hero-cards/${id}`, {
      baseURL: this.baseURL,
    });
  };
}
